var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "VDesc"
  }, [_c("a-collapse", {
    attrs: {
      bordered: false
    },
    scopedSlots: _vm._u([{
      key: "expandIcon",
      fn: function (props) {
        return [_c("a-icon", {
          attrs: {
            type: "down",
            rotate: props.isActive ? 0 : 180
          }
        })];
      }
    }]),
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.titleList, function (item) {
    return _c("a-collapse-panel", {
      key: item.key,
      staticClass: "author",
      style: _vm.customStyle,
      attrs: {
        id: item.key
      }
    }, [_c("template", {
      slot: "header"
    }, [_vm._v(_vm._s(item.title))]), item.title === "接口说明" ? _c("section", {
      staticClass: "desc-box",
      domProps: {
        innerHTML: _vm._s(_vm.interfaceDetail.detailed_description)
      }
    }) : _vm._e(), item.title === "应用场景" ? _c("section", [_c("ul", {
      staticClass: "desc-ul"
    }, _vm._l(_vm.interfaceDetail.scene, function (item, index) {
      return _c("li", {
        key: index
      }, [_c("p", {
        staticClass: "desc-title"
      }, [_vm._v(_vm._s(item.scene_name))]), _c("div", {
        staticClass: "desc-all",
        domProps: {
          innerHTML: _vm._s(item.scene_desc)
        }
      }), index !== _vm.interfaceDetail.scene.length - 1 ? _c("div", {
        staticClass: "one-line"
      }) : _vm._e()]);
    }), 0)]) : _vm._e(), item.title === "请求头部" ? _c("section", [_c("a-table", {
      attrs: {
        bordered: "",
        "data-source": _vm.interfaceDetail.interface_header_info,
        columns: _vm.requestInfoHeaderListColumns,
        pagination: false,
        rowKey: (record, index) => {
          return index;
        }
      }
    })], 1) : _vm._e(), item.title === "请求参数" ? _c("section", [_c("a-table", {
      attrs: {
        bordered: "",
        "data-source": _vm.interfaceDetail.interface_request_info,
        columns: _vm.requestInfoParamsListColumns,
        pagination: false,
        rowKey: (record, index) => {
          return index;
        }
      }
    })], 1) : _vm._e(), item.title === "返回参数" ? _c("section", [_c("a-table", {
      attrs: {
        bordered: "",
        "data-source": _vm.interfaceDetail.interface_result_info,
        columns: _vm.responseInfoParamsListColumns,
        pagination: false,
        rowKey: (record, index) => {
          return index;
        }
      }
    })], 1) : _vm._e(), item.title === "返回状态码" ? _c("section", [_c("a-table", {
      attrs: {
        bordered: "",
        "data-source": _vm.interfaceDetail.interface_code_info,
        columns: _vm.statusCodeListColumns,
        pagination: false,
        rowKey: (record, index) => {
          return index;
        }
      }
    })], 1) : _vm._e(), item.title === "成功示例" ? _c("section", [_c("div", {
      staticClass: "example"
    }, [_vm.interfaceDetail.success_mock && Object.keys(_vm.interfaceDetail.success_mock).length !== 0 ? _c("json-viewer", {
      attrs: {
        value: _vm.interfaceDetail.success_mock,
        theme: "my-awesome-json-theme",
        "expand-depth": 3,
        boxed: "",
        sort: ""
      }
    }) : _c("textarea", {
      staticClass: "example",
      attrs: {
        placeholder: "暂无示例",
        readonly: "readonly",
        autocomplete: "off"
      }
    })], 1)]) : _vm._e(), item.title === "失败示例" ? _c("section") : _vm._e()], 2);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };